import React from 'react';

import EmptyState from 'shared/empty_state';
import NylasGrant from 'components/nylas/v3/grant';
import * as providers from 'components/nylas/v3/providers';
import * as scopes from 'components/nylas/v3/scopes';

import type { Props as NylasGrantProps } from 'components/nylas/v3/grant';

interface Props {
  nylas: NylasGrantProps;
}

export default function CrmIntegrationSettings({ nylas }: Props) {
  return <>
    <h2>Connected Providers</h2>

    {!nylas.grant && <>
      <EmptyState
        bodyText="To automatically log emails as CRM Activities, connect an email provider from the list below."
        header="No Providers Connected"
      />
      <h2>Available Providers</h2>
    </>}

    <div className="ds-border-top ds-border-light mt-4 pt-4">
      <NylasGrant {...nylas} provider={providers.gmail} scopes={scopes.messageNotifications} />
    </div>
  </>;
}
